import { updateProject } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "./recordSentry";
import { createProject } from "db/queries/projectQueries";
import { Project, ProjectForResolver } from "db/definitions";

/**
 * Given the project values (which for now, is just the project name), the project id, and whether or not the user is online, updates the project with the new data
 * @author Eric Webb <ewebb@factorearth.com>
 * @param {Object} updatedProject The project with updated values
 * @param {boolean} online Whether or not the user is online
 */
export async function handleUpdateProject(updatedProject: Project, online: boolean): Promise<void> {
	try {
		if (online) {
			const updatedProdObj = {
				id: updatedProject.id,
				users: updatedProject.users,
				name: updatedProject.name,
				group: updatedProject.group,
			};
			const client = generateClient({ authMode: "userPool" });
			client.graphql({
				query: updateProject,
				variables: { input: updatedProdObj },
				authMode: "userPool",
			});
		} else {
			const dbProject: ProjectForResolver = {
				id: updatedProject.id,
				name: updatedProject.name,
				group: updatedProject.group,
				public: updatedProject.public,
				users: updatedProject.users,
				description: updatedProject.description || "",
				createdAt: updatedProject.createdAt || new Date().toISOString(),
				updatedAt: updatedProject.updatedAt || new Date().toISOString(),
			};
			await createProject(dbProject);
		}
	} catch (err) {
		recordSentry({ error: err, msg: "Error updating project:", showModal: true });
	}
}
